module.exports = __webpack_public_path__ + "../resources/img/ic_network_offline.7227d486.svg";